export enum FallbackMode {
  RedirectToAllReceptionWorkstations = 'RedirectToAll',
  NoRedirection = 'NoRedirection',
}
